<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'Agent'
}

</script>



// WEBPACK FOOTER //
// src/Adm/Agent/Agent.vue